import api from '@/utils/api';

const { baseApi } = window.GlobalConfig;

export const QueryPlanPage = data => {
    return api.post(`${baseApi}/visitPlan/getVisitPlanListPage`, data);
};

export const AddPlan = data => {
    return api.post(`${baseApi}/visitPlan/addVisitPlan`, data);
};

export const GetPlanInfo = ({ planId }) => {
    return api.get(`${baseApi}/visitPlan/getVisitPlanInfoById/${planId}`);
};

export const SubmitPlan = data => {
    return api.post(`${baseApi}/visitPlan/submitVisitPlan`, data);
};

export const DeletePlan = data => {
    return api.post(`${baseApi}/visitPlan/deleteVisitPlan`, data);
};

export const UpdateVisitPlan = data => {
    return api.post(`${baseApi}/visitPlan/updateVisitPlan`, data);
};

export const QueryReportPage = data => {
    return api.post(`${baseApi}/visit/getVisitListPage`, data);
};

export const QueryCustomerReport = data => {
    return api.post(`${baseApi}/visit/getVisitListByConditionsPage`, data);
};

export const AddReport = data => {
    return api.post(`${baseApi}/visit/addVisit`, data);
};

export const GetReportInfo = ({ visitId }) => {
    return api.post(`${baseApi}/visit/getVisitInfoById/${visitId}`);
};

export const SubmitReport = data => {
    return api.post(`${baseApi}`, data);
};

export const MarkPlanNotVisit = data => {
    return api.post(`${baseApi}/visitPlan/updateNotVisitPlan`, data);
};

export const GetProcessScorePage = data => {
    return api.post(`${baseApi}/performance/getProcessScorePage`, data);
};

export const GetUserScorePage = data => {
    return api.post(`${baseApi}/visit/getProcessScoreByCurrentUserRecursivePage`, data);
};

// 下属计划

export const QuerySubPlanPage = data => {
    return api.post(`${baseApi}/visitPlan/getVisitPlanSubordinatesPage`, data);
};

// 下属汇报

export const QuerySubReportPage = data => {
    return api.post(`${baseApi}/visit/getVisitListBySubordinatePage`, data);
};

// 行动计划

export const QueryActionList = data => {
    return api.post(`/actionPlan/getActionPlanPage`, data);
};

export const QuerySubActionList = data => {
    return api.post(`/actionPlan/getActionPlanInfo4SubordinatesPage`, data);
};

export const AddAction = data => {
    return api.post(`/actionPlan/addActionPlan`, data);
};

// export const UpdateAction = data => {
//     return api.post(`/actionPlan/updateActionPlanByOwner`, data);
// };

// 确认行动
export const ConfirmAction = data => {
    return api.post(`/actionPlan/updateActionPlanConfirm`, data);
};

// 验证行动
export const VerifyAction = data => {
    return api.post(`/actionPlan/updateActionPlanVerify`, data);
};

//更新行动计划
export const UpdateAction = data => {
    return api.post(`/actionPlan/updateActionPlan`, data);
};

//完成行动计划
export const FinishAction = data => {
    return api.post(`/actionPlan/updateActionPlanFinish`, data);
};

// 延期行动计划
export const DelayAction = data => {
    return api.post(`/actionPlan/updateActionPlanDelay`, data);
};

// 获取行动计划详情
export const GetActionInfo = ({ actionId }) => {
    return api.get(`/actionPlan/getActionPlanVoById/${actionId}`);
};

// export const DeleteAction = (actionId)=>{
//     return api.get(`/actionPlan/deleteActionPlanById/${actionId}`)
// }
export const MarkAction = data => {
    return api.post(`/actionPlan/updateActionPlanByAppraise`, data);
};

// 取消行动
export const DeleteAction = data => {
    return api.post(`/actionPlan/deleteActionPlan`, data);
};

export const CancelAction = data => {
    return api.post(`/actionPlan/updateActionPlanCancel`, data);
};

export const SaveWorkAction = data => {
    return api.post(``, data);
};

export const QueryWorkAction = data => {
    return api.post(``, data);
};

export const UpdateWorkAction = data => {
    return api.post(``, data);
};

// 异常风险

export const QueryAbnormal = data => {
    return api.post(``, data);
};

export const SaveAbnormal = data => {
    return api.post(``, data);
};

export const QueryAbnormalByCustomer = () => {
    return api.post(``);
};

export const QueryRisk = data => {
    return api.post(`/recordIssue/getRecordIssuePage`, data);
};

export const SaveRisk = data => {
    return api.post(`/recordIssue/addRecordIssue`, data);
};

export const UpdateRisk = data => {
    return api.post(`/recordIssue/updateRecordIssue`, data);
};

export const DealRisk = data => {
    return api.post(`/recordIssue/updateRecordIssueSolve`, data);
};

export const GetRiskInfo = ({ issueId }) => {
    return api.get(`/recordIssue/getRecordIssueVoById/${issueId}`);
};

export const GetActionListByIssueId = ({ issueId }) => {
    return api.get(`/actionPlan/getActionPlanByIssueId/${issueId}`);
};

export const QueryRiskByCustomer = data => {
    return api.post(``, data);
};

export const ConfirmRisk = data => {
    return api.post(`/recordIssue/updateRecordIssueConfirm`, data);
};

export const UnsolvableRisk = data => {
    return api.post(`/recordIssue/updateRecordIssueUnsolvable`, data);
};

export const ValidateRisk = data => {
    return api.post(`/recordIssue/updateRecordIssueVerify`, data);
};

// 重点工作

export const QueryFocusPage = data => {
    return api.post(`/actionKeypoint/getActionKeypointList4CurrentUserPage`, data);
};

export const SaveFocus = data => {
    return api.post(`/actionKeypoint/addActionKeypoint`, data);
};

export const DeleteFocus = ({ keypointId }) => {
    return api.get(`/actionKeypoint/deleteActionKeypoint/${keypointId}`);
};

export const UpdateFocus = data => {
    return api.post(`/actionKeypoint/updateActionKeypoint`, data);
};

export const GetFocusInfo = ({ keypointId }) => {
    return api.get(`/actionKeypoint/getActionKeypointById/${keypointId}`);
};

export const CancelKeypoint = data => {
    return api.post(`/actionKeypoint/updateActionKeypointCancel`, data);
};

export const ConfirmKeypoint = data => {
    return api.post(`/actionKeypoint/updateActionKeypointConfirm`, data);
};

export const FinishKeypoint = data => {
    return api.post(`/actionKeypoint/updateActionKeypointFinish`, data);
};

export const VerifyKeypoint = data => {
    return api.post(`/actionKeypoint/updateActionKeypointVerify`, data);
};

// 重要工作下的行动计划
export const QueryActionByFocus = data => {
    return api.post(``, data);
};

// 汇总
export const QueryTotalKeypoint = data => {
    return api.post(`/actionAnalysis/getKeypointList4IndicatorType`, data);
};

export const QuerySubKeypoint = data => {
    return api.post(`/actionAnalysis/getKeypointList4ParentId`, data);
};

export const QueryKeypointMain = data => {
    return api.post(`/actionKeypoint/getActionKeypointList4ManageUserPage`, data);
};

export const AssginKeypoint = data => {
    return api.post(`/actionKeypoint/addActionKeypointAssign`, data);
};
export const QuerySubKeypointPage = data => {
    return api.post(``, data);
};

export const QueryActionCount = data => {
    return api.post(`/actionKeypoint/getActionOverview`, data);
};

// 以用户维度查询数据
export const QueryUserData = data => {
    return api.post(`/actionKeypoint/getActionStatistics4UserPage`, data);
};

/// 查询每个客户的相关数据
export const QueryUserDetailData = data => {
    return api.post(`/actionKeypoint/getActionStatistics4UserDetail4VisitPlan`, data);
};

export const QueryUserDetailVisit = data => {
    return api.post(`/actionKeypoint/getActionStatistics4UserDetail4Visit`, data);
};

// 用户汇总

export const QueryUserMain = data => {
    return api.post(`/actionKeypoint/getActionStatistics4UserSummaryPage`, data);
};

export const QueryUserMainInfo = data => {
    return api.post(``, data);
};

export const QueryUserPlanList = data => {
    return api.post(`/visitPlan/getVisitPlanVoByConditions`, data);
};

export const QueryUserReportList = data => {
    return api.post(``, data);
};

// 计划行动计划二级查看
export const QueryUserActionList = data => {
    return api.post(`/actionPlan/getActionPlanListByVisitPlan`, data);
};

// 汇报行动计划二级查看
export const QueryUserActionVisitList = data => {
    return api.post(`/actionPlan/getActionPlanListByVisit`, data);
};
// 重点工作二级查看
export const QueryUserKeypointList = data => {
    return api.post(`/actionKeypoint/getActionKeypointListByVisitPlan`, data);
};

// 重点工作汇报查看
export const QueryUserKeypointVisitList = data => {
    return api.post(`/actionKeypoint/getActionKeypointListByVisit`, data);
};

export const QueryVisitPlanByKeypoint = data => {
    return api.post(`/visitPlan/getVisitPlanVoByConditions`, data);
};

export const QueryKeymanByParams = data => {
    return api.post(`/visit/getEmployeeList4VisitByConditions`, data);
};

//查询重要工作所以
export const QueryUserKeypointAll = data => {
    return api.post(`/actionKeypoint/getActionKeypointListByConditions`, data);
};

export const QueryUserCustomerPlan = data => {
    return api.post(``, data);
};

export const QuerySuggestionEdit = data => {
    return api.post(`/actionKeypointEdit/getActionKeypointEdit4CurrentUserPage`, data);
};

export const UpdateSuggestion = data => {
    return api.post(`/actionKeypoint/updateActionKeypointByEdit`, data);
};

export const QuerySuggestionPropose = data => {
    return api.post(`/actionKeypointEdit/getActionKeypointEditPage`, data);
};

export const QuerySuggestionPage = data => {
    return api.post(`/actionKeypointEdit/getActionKeypointEditPage`, data);
};

export const SaveSuggestion = data => {
    return api.post(`/actionKeypointEdit/addActionKeypointEdit`, data);
};

export const DeleteSuggestion = ({ editId }) => {
    return api.get(`/actionKeypointEdit/deleteActionKeypointEdit/${editId}`);
};

// 汇报关键人
export const QueryUserKeyman = data => {
    return api.post(`/visit/getVisitKeymanListByConditions`, data);
};
// 计划关键人
export const QueryUserPlankeyman = data => {
    return api.post(`/visitPlan/getEmployeeList4VisitPlanByConditions`, data);
};
// 用户拜访计划详情
export const QueryUserActionInfo = data => {
    return api.post(`/actionKeypoint/getActionStatistics4UserSummaryDetail4VisitPlan`, data);
};
// 用户拜访汇报详情
export const QueryUserActionVisitInfo = data => {
    return api.post(`/actionKeypoint/getActionStatistics4UserSummaryDetail4Visit`, data);
};

// 用户拜访下属计划详情
export const QueryUserSubPlanInfo = data => {
    return api.post(``, data);
};

// 用户拜访汇报计划详情
export const QueryUserSubVisitInfo = data => {
    return api.post(``, data);
};

// 符合率客户
export const QueryFitCustomer = data => {
    return api.post(``, data);
};

export const SaveSubmitPlan = data => {
    return api.post(`/visitPlan/saveAndSubmit`, data);
};

// 我的关注
export const QueryCollectionPage = data => {
    return api.post(`/actionKeypoint/getActionKeypointList4AttentionPage`, data);
};

// 收藏
export const UpdateCollection = data => {
    return api.post(`/actionKeypointAttentionRel/updateRel2Change`, data);
};

//作战地图重点工作
export const QueryKeypointMap = data => {
    return api.post(`/actionKeypoint/getActionKeypointList4ManageUserWithSelfPage`, data);
};

///我的指派工作

export const QueryAssginKeypointPage = data => {
    return api.post(`/actionKeypointAssign/getActionKeypointAssignList4CurrentUserPage`, data);
};

export const SaveAssginKeupoint = data => {
    return api.post(`/actionKeypointAssign/addActionKeypointAssign`, data);
};

export const UpdateAssginKeypoint = data => {
    return api.post(`/actionKeypointAssign/updateActionKeypointAssign`, data);
};

export const DeleteAssginKeypoint = ({ assignId }) => {
    return api.get(`/actionKeypointAssign/deleteActionKeypointAssign/${assignId}`);
};

export const ConfirmAssginKeypoint = ({ assignId }) => {
    return api.get(`/actionKeypointAssign/updateActionKeypointAssignConfirm/${assignId}`);
};

export const QueryAssginKeypointInfo = ({ assignId }) => {
    return api.get(`/actionKeypointAssign/getActionKeypointAssignById/${assignId}`);
};

export const QueryAssginKeypointAction = ({ assignKeypointId }) => {
    return api.get(`/actionKeypointAssign/getActionPlanAssignListByAssignKeypointId/${assignKeypointId}`);
};

export const LinkAssginKeypointAction = data => {
    return api.post(`/actionKeypointAssign/addActionPlanAssign`, data);
};

export const UpdateAssginKeypointAction = data => {
    return api.post(`/actionKeypointAssign/updateActionPlanAssign`, data);
};

export const QueryAssginKeypointActionInfo = ({ assignActionPlanId }) => {
    return api.get(`/actionKeypointAssign/getActionPlanAssignById/${assignActionPlanId}`);
};

export const DeleteAssginKeypointAction = ({ id }) => {
    return api.delete(`/actionKeypointAssign/deleteActionPlanAssign/${id}`);
};

//符合率
export const QueryFitRate = data => {
    return api.post(`/actionKeypoint/getActionStatistics4UserSummaryDetail4PlanCustomerComplianceRate`, data);
};

export const QueryAreaMain = data => {
    return api.post(`/actionKeypoint/getActionStatistics4AreaSummary`, data);
};

//
export const VerifyPasssAll = data => {
    return api.post(`/actionPlan/updateActionPlanVerifyBatch`, data);
};

//
export const QueryWithoutPlan = data => {
    return api.post(`/visitPlan/getVisitPlanWithoutVisit`, data);
};
